import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {  forgotPassword} from "../../Redux/actions/authActions";
import { Link, useNavigate } from "react-router-dom";
import "./FP.css";
import Navbar_back_btn from "../../UiComponents/Navbar_back_btn";
import SuccessModal from "../Dashboard/SuccessModal";
import {verifyOTP, resndOTP } from "../../Redux/actions/authActions";
import VerifyOTPModal from "./VerifyOtp";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOtpSuccess, setIsOtpSuccess] = useState(false);
  const [otp, setOpt] = useState('');
  const [inValidOtp, setInValidOtp] = useState('');
  const [inValid, setInValid] = useState('');
  const [otpType,setOtpType] = useState('');
  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await dispatch(forgotPassword(email));
      if (res?.success) {
        setIsOtpSuccess(true)
        setOtpType(res?.otpType)
        setInValidOtp('')
      } 
      else {
         setInValidOtp(res?.response?.data.message)
      }
    } catch (error) {
      console.log("error", error);
    }

  };
  const handleSubmitOtp = async () => {
    if (otp) {
      const res = await dispatch(verifyOTP(otp, otpType ,password));
      if (res?.status === 200 && res?.data === "Password updated successfully") {
        setIsOtpSuccess(false);
        setOpt('')  
        setInValidOtp('')
        setInValid('')
        navigate("/home/dashboard");
      } else if (res?.response?.data === "Invalid otp") {
        setInValid(res?.response?.data)
      } 
    }   
  }
  const handleResendOtp = async () => {
    const res = await dispatch(resndOTP());
    if (res?.data?.message === "otp Resent successsful") {
      setInValid(`OTP Resent Check Your Mail Agian`)
    }
  }
  return (
    <div className="main_div">
      <Navbar_back_btn  path='/home/login'/>
        {isOtpSuccess &&
        <VerifyOTPModal
          isOtpSuccess={isOtpSuccess}
          setIsOtpSuccess={setIsOtpSuccess}
          otp={otp} setOpt={setOpt}
          handleSubmitOtp={handleSubmitOtp}
          handleResendOtp={handleResendOtp}
          password={password} setPassword={setPassword}
          inValid={inValid}
        />}
      <div className="Sub_div ">
        <div className="forget_text">Reset Password</div>
        <form onSubmit={submitHandler}>
          <div className="mb-6 mt-6 ">
            {/* <label
              htmlFor="email"
              className="label_text "
            >
              Email address
            </label> */}
            <input
              type="email"
              id="email"
              className="input_block FontFamily-Avenir-reg"
              placeholder="Enter email ID"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}  
            />
          </div>
          <p className='inValidOtpFP'>{inValidOtp ? inValidOtp :null}</p>
          <div className="flex justify-end submit-box">
            <div className="login_div_2 ">
              <button type="submit" className="Login_btn text-lg">
                Submit
              </button>
            </div>

          </div>
        </form>
      </div>
      <div className="legal_block">
        <div className="legal_block_1">
          <h4 className="legal_c_text">c</h4>
          <h4 className="legal_rights_text">
            2022 Elements , All rights reserved
          </h4>
        </div>
        <div>
          <h4 className="legal_rights_text">legal</h4>
        </div>
      </div>
    </div>
  );
}
